export default {
  all: null,
  hospitalsVectorLayer: undefined,
  styleCacheHospital: [],
  hospitals: null,
};
